import { render, staticRenderFns } from "./DeliveryDashboard.vue?vue&type=template&id=06cc9f42&scoped=true&"
import script from "./DeliveryDashboard.vue?vue&type=script&lang=js&"
export * from "./DeliveryDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDashboard.vue?vue&type=style&index=0&id=06cc9f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc9f42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06cc9f42')) {
      api.createRecord('06cc9f42', component.options)
    } else {
      api.reload('06cc9f42', component.options)
    }
    module.hot.accept("./DeliveryDashboard.vue?vue&type=template&id=06cc9f42&scoped=true&", function () {
      api.rerender('06cc9f42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/delivery-dashboard/DeliveryDashboard.vue"
export default component.exports